import {Component} from "react";
import * as React from "react";

import {Link} from "react-router-dom";

export interface TableRowProps
{
    enableRowLink?: boolean;
    to?: string;
    openInNewTab?: boolean;
    onClick?: () => any;
    selected?: boolean;
    style?: any;
    extraClassName?: string;
}

interface TableRowState
{

}

export default class TableRow extends Component<TableRowProps,TableRowState>
{
    public componentDidMount() {
    }
    
    public render() {

        let RowComponent: any = "div";
        if(this.props.enableRowLink)
        {
            RowComponent = Link;
        }

        const clickableClass = this.props.onClick ? "cdb-table__row--clickable" : "";
        const selectedClass = this.props.selected ? "cdb-table__row--selected" : "";
        
        const rowProps: any = {
            className: `cdb-table__row ${clickableClass} ${selectedClass} ${this.props.extraClassName || ""}`, 
            style: this.props.style,
            onClick: this.props.onClick,
            to: this.props.to,
        };
        
        if(this.props.openInNewTab)
        {
            rowProps.target = "_blank";
            rowProps.rel = "noopener noreferrer";
        }
        
        
        return (
            <RowComponent {...rowProps}>
                {this.props.children}
            </RowComponent>
        );
    }
}